<template>
  <div class="row">
    <div v-bind:class="{
      'col-sm-6': question.image,
      'col-sm-12': !question.image
    }">
      <p>
        {{ question.num ? question.num + '. ' : '' }}
        <span @click="$parent.play(question.audio)"
          v-on:mouseover="speakerHover = true"
          v-on:mouseout="speakerHover = false"
          v-if="question.audio && canAudioReplay">
          <img class="clickable" src="../../assets/images/btn_play_sound_off.png" v-if="!speakerHover" />
          <img class="clickable" src="../../assets/images/btn_play_sound_on.png" v-else />
        </span>
      </p>

      <p v-if="question.image">
        <img :src="question.image" width="100%" />
      </p>

      <p v-if="question.title" class="pre" v-html="question.title"></p>

      <p v-if="question.descritpion" class="pre" v-html="question.descritpion"></p>
    </div>

    <div v-bind:class="{ 'col-sm-6': question.image, 'col-sm-12': !question.image }">
      <Options :items="question.items"
        :selected="selected.answers"
        v-on:answer="handleAnswer"></Options>
    </div>
  </div>
</template>

<script>
  import Options from './Options.vue'

  export default {

    name: 'MultiChoice',

    components: {
      Options
    },

    props: {
      question: {
        type: Object,
        required: true,
        default: () => {
          return {}
        }
      },

      selected: {
        type: Object,
        required: false,
        default: () => {
          return {}
        }
      },

      canAudioReplay: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    data () {
      return {
        audio: null,
        speakerHover: false
      }
    },

    methods: {
      handleAnswer (answer) {
        answer.id = this.question.id
        this.$emit('answer', answer)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .clickable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// MultiChoice.vue?85d7499a